import type { Story } from '@/store/story-types'

export const TECH_GADGET_STORE_NEW3_STORY: Story = {
  id: 'tech-gadget-store-new3',
  name: 'ByteGear — Tech Gadget Store',
  narrative: 'A sleek electronics store with the latest gadgets, accessories, and smart devices. Users browse tech products, view specs, and complete purchases.',
  goals: ['Browse tech gadget catalog', 'View detailed specifications and reviews', 'Add gadgets to cart', 'Complete secure checkout'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Landing page with featured gadgets and category navigation' },
    { id: 'pg-detail', title: 'Product Detail', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'product-detail', description: 'Product detail with specs, images, and reviews' },
    { id: 'pg-cart', title: 'Cart', order: 2, status: 'completed', elementCount: 4, linkedPageId: 'cart', description: 'Shopping cart with items and total' },
    { id: 'pg-checkout', title: 'Checkout', order: 3, status: 'completed', elementCount: 4, linkedPageId: 'checkout', description: 'Checkout with payment and shipping' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Tech Products',
      description: 'User browses the tech gadget catalog',
      steps: [
        { type: 'given', text: 'the user opens the tech store' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'gadget cards with images, names, and prices are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'View Product Specs',
      description: 'User views detailed specifications',
      steps: [
        { type: 'given', text: 'the user is browsing gadgets', linkedPageId: 'home' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'product detail with full specs is displayed', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3', name: 'Add to Cart',
      description: 'User adds a gadget to cart',
      steps: [
        { type: 'given', text: 'the user is on product detail', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the gadget is added and cart updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4', name: 'Complete Purchase',
      description: 'User completes checkout',
      steps: [
        { type: 'given', text: 'the user has items in cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout and submit' },
        { type: 'then', text: 'order confirmed and cart cleared', linkedPageId: 'checkout' },
      ],
    },
  ],
}
